/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateUnitPaymentsPermission} from '../api'

export const useMutationUpdateUnitPaymentsPermission = createReactQueryMutationHook('updateUnitPaymentsPermission', updateUnitPaymentsPermission)
